import { UsePlayerStatisticsQueryKeyProps } from './props';
import { PlayersQueryKeys } from '../../queryKey';
import { useModal, useSearchParams } from '@starsoft/common/hooks';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { fetchPlayerWithStats } from './service';
import { PlayerStatisticsRequestDto } from '@/services/dto/players/player-statistics-request.dto';
import { PlayerWithStats } from '@/models/player/with-stats';
import { useUserAccount } from '@/api/user/queries';
import { ModalsKey } from '@/enums/modalsKey';

export function usePlayerStatistics() {
  const { isOpen } = useModal(ModalsKey.UserProfile);
  const search = useSearchParams();
  const { user } = useUserAccount();

  const slug = search.get('player-slug');
  const userSlug = search.get('userSlug');
  const coallescedSlug = slug || user?.player?.slug || userSlug;

  const params: PlayerStatisticsRequestDto = {
    slug: coallescedSlug as string,
  };

  const queryKey: UsePlayerStatisticsQueryKeyProps = [
    PlayersQueryKeys.Statistics,
    params,
  ];

  const { data, isPending, fetchStatus, error, refetch } = useQuery<
    PlayerWithStats,
    AxiosError<GenericError>,
    PlayerWithStats,
    UsePlayerStatisticsQueryKeyProps
  >({
    queryKey,
    queryFn: fetchPlayerWithStats,
    refetchOnWindowFocus: false,
    enabled: !!coallescedSlug && isOpen,
    staleTime: 5 * 1000,
  });

  return {
    error,
    refetch,
    player: data,
    isPending: isPending && fetchStatus !== 'idle',
  };
}
